import { LayerFilter, UserFilter } from '@/home/analyze/analyze-filters';
import { TilesFilterType } from 'src/app/core/models/activity';
import { SelectOption } from '@/core/types/angular-primeng-api';
import { TranslateService } from '@ngx-translate/core';
import { UserForm } from '@/core/models/account';

/**
 * @class SharedFunctions
 *
 * The methods of the SharedFunctions class are a collection of any not bigger functionality,
 * that shall be reused in different components or services, but are so small that creating an own service is not worth it.
 *
 */
export class SharedFunctions {
    public static startAppDownload(): void {
        const os = SharedFunctions.getOS();
        switch (os) {
            case 'Mac':
                return SharedFunctions.downloadAppMac();
            case 'Windows':
                return SharedFunctions.downloadAppWin();
            case 'Linux':
                return SharedFunctions.downloadAppLinux();
        }
        console.warn('OS not supported for download');
    }

    public static downloadAppWin(): void {
        window.open('https://timebuzzer.com/get/timeBuzzer.exe', '_self', 'noopener');
    }

    public static downloadAppMac(): void {
        window.open('https://timebuzzer.com/get/timeBuzzer.dmg', '_self', 'noopener');
    }

    public static downloadAppLinux(): void {
        window.open('https://timebuzzer.com/get/timeBuzzer.AppImage', '_self', 'noopener');
    }

    public static getOS(): 'Mac' | 'Windows' | 'Linux' | 'iOS' | 'Android' | 'Other' {
        const navi = window.navigator;

        // Preferred: Use userAgentData.platform if available
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const platform = (navi as any).userAgentData?.platform || navi.platform;
        if (platform) {
            if (/iphone|ipad|ipod/i.test(platform)) return 'iOS';
            if (/mac/i.test(platform)) return 'Mac';
            if (/win/i.test(platform)) return 'Windows';
            if (/linux/i.test(platform)) return 'Linux';
            if (/android/i.test(platform)) return 'Android';
        }

        // Fallback: Use userAgent string
        const userAgent = navi.userAgent;
        if (/Android/i.test(userAgent)) return 'Android';
        if (/iPad|iPhone|iPod/.test(userAgent)) return 'iOS';
        if (/Mac/i.test(userAgent)) return 'Mac';
        if (/Win/i.test(userAgent)) return 'Windows';
        if (/Linux/i.test(userAgent)) return 'Linux';

        return 'Other';
    }

    // TODO where to put this???
    public static getTilesDtoFromFilters(
        selectedLayer1Filter: LayerFilter[],
        selectedLayer2Filter: LayerFilter[],
        selectedLayer3Filter: LayerFilter[],
    ): TilesFilterType {
        return {
            1: selectedLayer1Filter.map((l) => l.id).length === 0 ? undefined : selectedLayer1Filter.map((l) => l.id),
            2: selectedLayer2Filter.map((l) => l.id).length === 0 ? undefined : selectedLayer2Filter.map((l) => l.id),
            3: selectedLayer3Filter.map((l) => l.id).length === 0 ? undefined : selectedLayer3Filter.map((l) => l.id),
        };
    }

    public static getLanguageOptions(translate: TranslateService): SelectOption[] {
        const supportedLanguages = window.__tb_lang.supportedLanguages;

        const langNames: Record<string, string> = translate.instant('languages');

        const langOptions: SelectOption[] = [];
        for (const lang of supportedLanguages) {
            const opt: SelectOption = {
                name: langNames[lang],
                code: lang,
            };
            langOptions.push(opt);
        }

        return langOptions;
    }

    public static getUserFilterOptions(users: UserForm[]): UserFilter[] {
        return users.map((user: UserForm) => {
            const userFilter: UserFilter = {
                name: user.firstName + ' ' + user.lastName,
                id: user.id,
            };
            return userFilter;
        });
    }
}
